import { render } from "./HeaderBanner.vue?vue&type=template&id=c031ee54&scoped=true"
import script from "./HeaderBanner.vue?vue&type=script&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&lang=js"

import "./HeaderBanner.vue?vue&type=style&index=0&id=c031ee54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c031ee54"]])

export default __exports__